import { createReducer } from '@reduxjs/toolkit'

import { arrayToObject } from 'utils/functions'
import { IAllocationKey } from 'types/GlobalAllocationKey'

import * as actions from '../../actions/AllocationKeys/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export type TAllocationKeyBody = {
  [key: string]: IAllocationKey
}

export interface IAllocationKeyReducerType {
  data: TAllocationKeyBody
  fetched: boolean
}

const INITIAL_STATE: IAllocationKeyReducerType = {
  data: {},
  fetched: false
}

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.createSuccess, (state, action) => {
      state.data[action.payload.data.id] = action.payload.data
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      state.data = arrayToObject<IAllocationKey>(action.payload.data)
      state.fetched = true
    })
    .addCase(actions.updateSuccess, (state, action) => {
      state.data[action.payload.data.id] = action.payload.data
    })
    .addCase(actions.destroySuccess, (state, action) => {
      delete state.data[action.payload]
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})
